import { ExternalIntegrationType } from "./types";

export const DYNAMIC_INTEGRATIONS: Array<{
  name: ExternalIntegrationType;
  label: string;
}> = [
  {
    name: "cape",
    label: "CAPE Sandbox"
  },
  {
    name: "cisco_secure_malware_analytics",
    label: "Cisco Secure Malware Analytics"
  },
  {
    name: "cuckoo",
    label: "Cuckoo Sandbox"
  },
  {
    name: "fireeye",
    label: "FireEye Sandbox"
  },
  {
    name: "joe",
    label: "Joe Sandbox"
  },
  {
    name: "vmray_tcbase",
    label: "VMRay"
  }
];

export const DEFAULT_MENU_STYLES = {
  maxHeight: 211,
  overflow: "auto",
  width: "100%"
};

export const UPLOAD_SOURCE_MESSAGES = {
  sourceTag:
    "Custom source tag for the sample upload. Uploads can be searched by this tag using the upload-source-tag keyword or upload-data group keyword.",
  fileOriginLink:
    "An external link to the location of the sample being uploaded (if available)."
};
